<template lang="pug">
  .b2b-page-usuarios
    transition(name="fade" mode="out-in")
      router-view(
        @duplicateData = 'duplicateData'
      )
</template>

<script>
import { mapActions } from 'vuex'
import router from '@/router/index'
import B2bPageUsuario from '@/views/administracion/usuarios/B2bPageUsuario.vue'
export default {
  name: 'b2b-page-usuarios',
  components: {
    B2bPageUsuario
  },
  methods: {
    ...mapActions([
      'B2bCreateConfig'
    ]),
    async duplicateData (duplicateUserData) {
      console.log(duplicateUserData)
      router.push({ name: 'createuser', params: { duplicateUserData: duplicateUserData } })
    }
  },
  created () {
    this.B2bCreateConfig()
  }
}
</script>

<style lang="scss" scoped>

</style>
